import { api } from '../index';
import apiUrls from '../../../settings/api-urls';
import { interpolate } from '../../../utilities';

export const orderSchemasApi = api.injectEndpoints({
    endpoints: (build) => ({
        getOrderSchemas: build.query({
            query: () => ({
                url: apiUrls.ORDER_SCHEMAS,
                method: 'GET',
            }),
            providesTags: [ 'ORDER_SCHEMAS' ],
        }),
        getOrderSchema: build.query({
            query: (orderSchemaId) => ({
                url: interpolate(apiUrls.ORDER_SCHEMAS_ITEM, { orderSchemaId }),
                method: 'GET',
            }),
            providesTags: (result, error, orderSchemaId) => [ { type: 'ORDER_SCHEMAS', id: orderSchemaId } ],
        }),
        createOrderSchema: build.mutation({
            query: (body) => ({
                url: apiUrls.ORDER_SCHEMAS,
                method: 'POST',
                body,
            }),
            invalidatesTags: [ 'ORDER_SCHEMAS' ],
        }),
        updateOrderSchema: build.mutation({
            query: ({ orderSchemaId, body }) => ({
                url: interpolate(apiUrls.ORDER_SCHEMAS_ITEM, { orderSchemaId }),
                method: 'PATCH',
                body,
            }),
            invalidatesTags: (result, error, { orderSchemaId }) => [ 'ORDER_SCHEMAS', { type: 'ORDER_SCHEMAS', id: orderSchemaId } ],
        }),
        deleteOrderSchema: build.mutation({
            query: (orderSchemaId) => ({
                url: interpolate(apiUrls.ORDER_SCHEMAS_ITEM, { orderSchemaId }),
                method: 'DELETE',
            }),
            invalidatesTags: [ 'ORDER_SCHEMAS' ],
        }),
        getOrderSchemaUsage: build.query({
            query: (orderSchemaId) => ({
                url: interpolate(apiUrls.ORDER_SCHEMA_USAGE, { orderSchemaId }),
                method: 'GET',
                silent: true,
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetOrderSchemasQuery,
    useLazyGetOrderSchemasQuery,
    useGetOrderSchemaQuery,
    useLazyGetOrderSchemaQuery,
    useCreateOrderSchemaMutation,
    useUpdateOrderSchemaMutation,
    useDeleteOrderSchemaMutation,
    useLazyGetOrderSchemaUsageQuery,
} = orderSchemasApi;
